module.exports = __webpack_public_path__ + "img/14.ad8108b3.webp";